import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartObserverService {

  public cart$ = new EventEmitter();

  private itemCounterSubject: BehaviorSubject<number> = new BehaviorSubject(0 as number);
  public readonly dataUser: Observable<number> = this.itemCounterSubject.asObservable();

  public setdatauser(itemsCount: number): void {
    this.itemCounterSubject.next(itemsCount);
  }
}
